// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ehskmwgoablwyqevwegt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVoc2ttd2dvYWJsd3lxZXZ3ZWd0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk2MDc4MjksImV4cCI6MjA1NTE4MzgyOX0.gJytLAGG4S1JLY6LvELhU4-nkjRqvpaJnce7zQ6AmUI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);